import type { CompanionDockAutoOpenReason } from "@/shared/lib/events";

export type { CompanionDockAutoOpenReason };

export const COMPANION_DOCK_AUTO_OPEN_POLICY: Record<CompanionDockAutoOpenReason, boolean> = {
  "agent-dispatch": true,
  "agent-activation": true,
  "chat-injection": true,
  "new-session": true,
  "page-connect": false,
  "route-entry": false,
  "onboarding-showcase": false,
  "overlay-host": false,
} as const;

export const CLOSED_COMPANION_DOCK_STATE = {
  chatOpen: false,
  dockedPanelHidden: true,
} as const;

export const OPEN_COMPANION_DOCK_STATE = {
  chatOpen: true,
  dockedPanelHidden: false,
} as const;

export function shouldAutoOpenCompanionDock(reason: CompanionDockAutoOpenReason): boolean {
  return COMPANION_DOCK_AUTO_OPEN_POLICY[reason];
}
